import React from 'react';
import { stack as Menu } from 'react-burger-menu';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import SVG from 'react-inlinesvg';

import './index.css';
import { toggleSidebar } from '../../actions';
import close from '../../images/closeSidebar.svg'
import facebook from '../../images/facebook-logo.svg'
import behance from '../../images/behance-logo.svg'
import pinterest from '../../images/pinterest-logo.svg'

class Sidebar extends React.Component {
  state = {
    isOpen: false
  }

  isSidebarOpen(state) {
    this.props.sidebarIsOpen ? document.body.style.overflow = 'hidden' : document.body.style.overflow = 'auto';
    this.setState({ isOpen: this.props.sidebarIsOpen })
    return this.props.sidebarIsOpen;
  }

  handleSideBarLink = (e, link) => {
    e.preventDefault();
    this.setState({
      isOpen: !this.state.isOpen
    })
    this.props.toggleSidebar(!this.state.isOpen);
    this.props.history.push(link);
  }

  render() {
    return (
      <Menu
        onStateChange={(state) => this.isSidebarOpen(state)}
        isOpen={this.props.sidebarIsOpen}
        width={'100vw'}
        className="sidebar">
        <div className="sidebar__header">
          <div onClick={() => this.props.toggleSidebar(false)}>
            <SVG src={close} className="sidebar__close" />
          </div>
        </div>
        <NavLink
          to="/"
          exact
          className="sidebar__link"
          activeClassName="sidebar__link-active"
          onClick={(e) => this.handleSideBarLink(e, '/')}>Главная</NavLink>
        <NavLink
          to="/web"
          className="sidebar__link"
          activeClassName="sidebar__link-active"
          onClick={(e) => this.handleSideBarLink(e, '/web')}>Web</NavLink>
        <NavLink
          to="/mobile"
          className="sidebar__link"
          activeClassName="sidebar__link-active"
          onClick={(e) => this.handleSideBarLink(e, '/mobile')}>Mobile</NavLink>
        <NavLink
          to="/portfolio"
          className="sidebar__link"
          activeClassName="sidebar__link-active"
          onClick={(e) => this.handleSideBarLink(e, '/portfolio')}>Портфолио</NavLink>
        <NavLink
          to="/about"
          className="sidebar__link"
          activeClassName="sidebar__link-active"
          onClick={(e) => this.handleSideBarLink(e, '/about')}>О нас</NavLink>
        <NavLink
          to="/blog"
          className="sidebar__link"
          activeClassName="sidebar__link-active"
          onClick={(e) => this.handleSideBarLink(e, '/blog')}>Блог</NavLink>
        <NavLink
          to="/vacancies"
          className="sidebar__link"
          activeClassName="sidebar__link-active"
          onClick={(e) => this.handleSideBarLink(e, '/vacancies')}>Вакансии</NavLink>
        <NavLink
          to="/contacts"
          className="sidebar__link"
          activeClassName="sidebar__link-active"
          onClick={(e) => this.handleSideBarLink(e, '/contacts')}>Контакты</NavLink>
        <div className="sidebar__footer">
          <a href="https://www.facebook.com/login/?next=https%3A%2F%2Fwww.facebook.com%2Fgroups%2F249633105595577%2F">
            <SVG src={facebook} />
          </a>
          <a href="https://www.pinterest.ru/leotrado/">
            <SVG src={pinterest} />
          </a>
          <a href="https://www.behance.net/leotrado8901">
            <SVG src={behance} />
          </a>
        </div>
      </Menu>
    )
  }
}

const mapStateToProps = ({ sidebarIsOpen }) => {
  return {
    sidebarIsOpen
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    toggleSidebar: (flag) => dispatch(toggleSidebar(flag))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);


// WEBPACK FOOTER //
// ./src/components/sidebar/index.jsx